import { addArticle, getAllArticles, uploadImage, updateArticle, addComment, getFlag, deleteArticle } from '../../api'
export default ({
    state: {
        articlesList: [],
        allArticlesList: [],
        articleAdventureMap: {},
        flagMap: {},
        artCountryMap: {},
        timeline: []
    },
    mutations: {
        SET_ALL_ARTICLES_LIST(state, data) {
            state.allArticlesList = data
        },
        SET_ARTICLES_LIST(state, data) {
            state.articlesList = data
        },
        SET_ADV_ART_MAP(state, data) {
            state.articleAdventureMap = data
        },
        SET_FLAG_MAP(state, data) {
            state.flagMap = data
        },
        SET_COUNTR_UNIQ_MAP(state, data) {
            state.artCountryMap = data
        },
        SET_TIMELINE(state, data) {
            state.timeline = data
        }
    },
    actions: {
        async addArticle({ state, dispatch }, { title, country, content, continent, markers, adventure, desc, image, date }) {
            const id = await addArticle(title, country, content, continent, markers, adventure, desc, image, date.getTime())
            const list = state.articlesList = [
                ...state.articlesList, { ownId: id, title, country, content, continent, markers, adventure, desc, image, date }
            ]
            alert('Article créé')
            dispatch('onAllArticlesFetch', list)
            dispatch('setStructure')
        },
        async updateArticle({ state, dispatch }, { article, ownId }) {
            try {

                await updateArticle(article, ownId)
                alert('Article mis a jour')
                const i = state.allArticlesList.findIndex(data => data.ownId === ownId)
                const list = state.allArticlesList = [
                    ...state.allArticlesList.slice(0, i),
                    { ...article, ownId },
                    ...state.allArticlesList.slice(i + 1),
                ]
                dispatch('onAllArticlesFetch', list)
                dispatch('setStructure')

                return
            } catch (e) {
                console.log(e)
            }
        },
        async onAllArticlesFetch({ commit }, r) {
            const sorted = r.sort((a, b) => {

                const nA = a.date ? a.date : Date.now();
                const nB = b.date ? b.date : Date.now();
                return nB - nA;
            })
            commit('SET_ALL_ARTICLES_LIST', sorted)
            const result = sorted.reduce((acc, curr) => {
                return curr.published ? [...acc, curr] : acc;
            }, [])

            commit('SET_ARTICLES_LIST', result)
            const map = result.reduce((acc, art) => {
                if (art.adventure) {
                    if (acc[art.adventure]) {
                        acc[art.adventure].push(art)
                    } else {
                        acc[art.adventure] = [art]
                    }
                }
                return acc;
            }, {})
            commit('SET_ADV_ART_MAP', map)
            const mapCountryUniq = Object.entries(map).reduce((acc, pair) => {
                const [key, value] = pair;
                const uniq = [...new Set(value.map((c) => c.country))];
                return {
                    ...acc,
                    [key]: uniq
                }
            }, {})

            commit('SET_COUNTR_UNIQ_MAP', mapCountryUniq)

            const flagArray = result.reduce((acc, { country }) => {
                if (acc.includes(country)) {
                    return acc
                } else {
                    return [...acc, country]
                }
            }, [])
            const urlFlag = await Promise.all(flagArray.map(c => getFlag(c)))
            const flagMap = urlFlag.reduce((acc, { country, url }) => {
                return {
                    ...acc,
                    [country]: url
                }
            }, [])
            commit('SET_FLAG_MAP', flagMap)

            //timeline

            const timeline = result.reduce((acc, curr) => {
                const date = curr.date ? new Date(curr.date) : new Date()
                const year = date.getFullYear()
                if (acc.length === 0) {

                    return [{ year, country: curr.country, continent: curr.continent, flag: `https://www.countryflags.io/${curr.country.toLowerCase()}/flat/64.png` }]
                }
                if (acc[acc.length - 1].country !== curr.country) {
                    return [...acc, { year, continent: curr.continent, country: curr.country, flag: `https://www.countryflags.io/${curr.country.toLowerCase()}/flat/64.png` }]
                }
                return acc
            }, [])
            commit('SET_TIMELINE', timeline)

        },
        async getAllArticles({ dispatch }) {
            const r = await getAllArticles()
            dispatch("onAllArticlesFetch", r)

        },
        async uploadImage(store, file) {
            const { url, path } = await uploadImage(file)
            return { url, path };
        },
        async addComment({ state, dispatch }, { id, pseudo, comment, comments }) {
            const newComments = [{ pseudo, comment, date: Date.now() }, ...comments]
            await addComment(id, newComments)
            const i = state.articlesList.findIndex(data => data.ownId === id)
            const list = state.articlesList = [
                ...state.articlesList.slice(0, i),
                { ...state.articlesList[i], comments: newComments },
                ...state.articlesList.slice(i + 1),
            ]
            dispatch('setCurrentArticle', { ...state.articlesList[i], comments: newComments })
            dispatch('onAllArticlesFetch', list)
            dispatch('setStructure')
        },
        async deleteArticle({ state, dispatch }, id) {
            try {
                await deleteArticle(id)
                alert('Article mis a jour')
                const i = state.articlesList.findIndex(data => data.ownId === id)
                const list = state.articlesList = [
                    ...state.articlesList.slice(0, i),
                    ...state.articlesList.slice(i + 1),
                ]
                dispatch('onAllArticlesFetch', list)
                dispatch('setStructure')

                return
            } catch (e) {
                console.log(e)
            }
        },
    },
    getters: {
        getDraftArticles: state => state.allArticlesList,
        getAllArticles: state => state.articlesList,
        getLastArticles: state => state.articlesList.slice(0, 3),
        getFlagMap: state => state.flagMap,
        getArticleAdMap: state => state.articleAdventureMap,
        getArtCountryMap: state => state.artCountryMap,
        getTimeline: state => state.timeline,
        getArticlesForCurrentAdventure: (state, getters, rootState) => {
            return rootState.adventure.currentAdventure ? state.articleAdventureMap[rootState.adventure.currentAdventure.ownId] : []
        }
    }
})